import styled from '@emotion/styled';

export const QuestionContent = styled.div`
    user-select: text;

    .title span {
        cursor: text;
    }
`;
